<div class="main-content" *ngIf="canRead()">

  <!-- ─── HEADER (stesso design di /damage-overview) ─── -->
  <div class="header-section">
    <div class="wm-heading">
      <div class="wm-heading-icon wm-heading-icon--orange">
        <i class="fas fa-users"></i>
      </div>
      <div>
        <h1 class="main-title">Panoramica Clienti</h1>
        <p class="main-subtitle">Pratiche danno viste per cliente</p>
      </div>
    </div>

    <!-- Utente collegato e collegamenti alle pagine della gestione danni -->
    <app-damage-nav-box #navBox></app-damage-nav-box>

    <!-- Strumentario -->
    <div class="toolbox-container">
      <div class="toolbox-heading">
        <div class="toolbox-heading-icon">
          <i class="fas fa-tools"></i>
        </div>
        <div class="toolbox-heading-text">
          <span class="toolbox-title">Strumentario</span>
          <small class="toolbox-subtitle">Strumenti rapidi</small>
        </div>
      </div>
      <div class="toolbox-divider"></div>
      <div class="toolbox-buttons">

        <!-- Aggiorna dati -->
        <button type="button" class="toolbox-btn toolbox-btn--green" (click)="refreshData()"
                [disabled]="isLoading"
                title="Aggiorna i dati (ri-esegue la ricerca con i filtri correnti)">
          <i class="fas fa-sync-alt" [class.fa-spin]="isLoading"></i>
        </button>

        <!-- Comprimi/Espandi sezioni -->
        <button type="button" class="toolbox-btn toolbox-btn--purple" (click)="toggleAllSections()"
                title="Comprimi/Espandi filtri, resoconto e clienti">
          <i class="fas" [ngClass]="areAllSectionsCollapsed ? 'fa-expand-alt' : 'fa-compress-alt'"></i>
        </button>

        <!-- Densità tabella -->
        <button type="button" class="toolbox-btn toolbox-btn--orange" [class.active]="isCompactTable"
                (click)="toggleCompactTable()"
                title="Attiva/Disattiva la vista compatta delle tabelle">
          <i class="fas fa-grip-lines"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- ─── SEZIONE 1: FILTRI & AZIONI ─── -->
  <div id="filters-section" class="card mb-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-filter header-icon"></i>
          <h3>Filtri &amp; Azioni</h3>
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary"
                (click)="toggleFiltersCollapsed()"
                [title]="isFiltersCollapsed ? 'Espandi' : 'Comprimi'">
          <i class="fas" [ngClass]="isFiltersCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
        </button>
      </div>
    </div>

    <div class="card-body" *ngIf="!isFiltersCollapsed">
      <div class="row g-3">

        <!-- Cliente: dimensione principale della pagina, per primo e più largo -->
        <div class="col-md-6">
          <label class="form-label">Cliente</label>
          <app-searchable-select
                  [(ngModel)]="filterClient"
                  [options]="clientSelectOptions"
                  [multiple]="true"
                  allOptionLabel="Tutti i clienti"
                  icon="fas fa-user"
                  searchPlaceholder="Cerca cliente...">
          </app-searchable-select>
        </div>

        <div class="col-md-3">
          <label class="form-label">Stato</label>
          <app-searchable-select
                  [(ngModel)]="filterStatus"
                  [options]="statusOptions"
                  [multiple]="true"
                  allOptionLabel="Tutti gli stati"
                  icon="fas fa-flag"
                  searchPlaceholder="Cerca stato...">
          </app-searchable-select>
        </div>

        <div class="col-md-3">
          <label class="form-label">Pratica</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-folder-open filter-icon"></i>
            <input type="text" class="filter-input" [(ngModel)]="filterDamageCode"
                   placeholder="Filtra per codice pratica..." (keydown.enter)="search()">
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Codice Collo</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-box filter-icon"></i>
            <input type="text" class="filter-input" [(ngModel)]="filterParcelCode"
                   placeholder="Filtra per codice collo..." (keydown.enter)="search()">
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Codice Bolla</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-barcode filter-icon"></i>
            <input type="text" class="filter-input" [(ngModel)]="filterWaybillCode"
                   placeholder="Filtra per codice bolla..." (keydown.enter)="search()">
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Gravità</label>
          <app-searchable-select
                  [(ngModel)]="filterSeverity"
                  [options]="severityOptions"
                  [multiple]="true"
                  allOptionLabel="Tutte le gravità"
                  icon="fas fa-exclamation-triangle"
                  searchPlaceholder="Cerca gravità...">
          </app-searchable-select>
        </div>

        <div class="col-md-3">
          <label class="form-label">Tipo Danno</label>
          <app-searchable-select
                  [(ngModel)]="filterType"
                  [options]="typeOptions"
                  [multiple]="true"
                  allOptionLabel="Tutti i tipi"
                  icon="fas fa-tag"
                  searchPlaceholder="Cerca tipo...">
          </app-searchable-select>
        </div>

        <div class="col-md-3">
          <label class="form-label">Assegnata a</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-user-check filter-icon"></i>
            <input type="text" class="filter-input" [(ngModel)]="filterAssignedTo"
                   placeholder="Filtra per operatore..." (keydown.enter)="search()">
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Aperta dal</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-calendar-plus filter-icon"></i>
            <input #openedFromInput type="text" class="filter-input" readonly placeholder="Data apertura dal...">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn" (click)="shiftOpenedFrom(-1)" title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="setOpenedFromToday()" title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="shiftOpenedFrom(1)" title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="clearOpenedFrom()" title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Aperta al</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-calendar-minus filter-icon"></i>
            <input #openedToInput type="text" class="filter-input" readonly placeholder="Data apertura al...">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn" (click)="shiftOpenedTo(-1)" title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="setOpenedToToday()" title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="shiftOpenedTo(1)" title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="clearOpenedTo()" title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Solo scadute: stesso interruttore di /damage-overview -->
        <div class="col-md-3">
          <label class="form-label">Scadenza</label>
          <div class="filter-input-wrapper damaged-filter-wrapper">
            <i class="fas fa-hourglass-end filter-icon"></i>
            <span class="damaged-filter-text" [class.active]="onlyOverdue">
              {{ onlyOverdue ? 'Solo pratiche scadute' : 'Tutte le scadenze' }}
            </span>
            <button type="button" class="damaged-filter-switch"
                    role="switch" [attr.aria-checked]="onlyOverdue"
                    [class.active]="onlyOverdue"
                    (click)="onlyOverdue = !onlyOverdue"
                    [title]="onlyOverdue ? 'Mostra tutte le pratiche' : 'Mostra solo le pratiche aperte con scadenza superata'">
              <span class="damaged-filter-switch-knob">
                <i class="fas" [ngClass]="onlyOverdue ? 'fa-exclamation' : 'fa-check'"></i>
              </span>
            </button>
          </div>
        </div>

      </div>

      <!-- Azioni -->
      <div class="mt-4 pt-3 border-top">
        <div class="d-flex justify-content-end align-items-center gap-2">
          <button class="btn btn-outline-secondary btn-sm" type="button" (click)="resetFilters()">
            <i class="fas fa-undo me-1"></i> Reimposta
          </button>
          <button class="btn btn-primary btn-sm" type="button" (click)="search()" [disabled]="isLoading">
            <i class="fas me-1" [ngClass]="isLoading ? 'fa-spinner fa-spin' : 'fa-search'"></i>
            Cerca
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ─── SEZIONE 2: RESOCONTO (della selezione corrente) ─── -->
  <div id="summary-section" class="card mb-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-chart-bar header-icon"></i>
          <h3>Resoconto</h3>
          <!-- Cliente a fuoco: il resoconto e le pratiche sono solo sue -->
          <span class="dco-focus-chip" *ngIf="focusedClientName as name" [title]="'Resoconto del cliente ' + name">
            <i class="fas fa-user me-1"></i>{{ name }}
            <button type="button" class="dco-focus-chip-clear" (click)="clearClientFocus()" title="Torna a tutti i clienti">
              <i class="fas fa-times"></i>
            </button>
          </span>
        </div>
        <div class="d-flex align-items-center gap-2">
          <div class="dmg-summary-error" *ngIf="summaryErrorMessage" role="alert">
            <i class="fas fa-exclamation-circle dmg-summary-error-icon"></i>
            <span class="dmg-summary-error-text">{{ summaryErrorMessage }}</span>
            <button type="button" class="dmg-summary-error-retry"
                    (click)="retrySummary()"
                    [disabled]="isLoadingSummary"
                    title="Riprova a caricare il resoconto">
              <i class="fas fa-redo-alt" [class.fa-spin]="isLoadingSummary"></i>
              Riprova
            </button>
          </div>
          <button type="button" class="btn btn-sm btn-outline-secondary"
                  (click)="toggleReportCollapsed()"
                  [title]="isReportCollapsed ? 'Espandi' : 'Comprimi'">
            <i class="fas" [ngClass]="isReportCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="card-body" *ngIf="!isReportCollapsed">
      <div class="dmg-metrics-grid">

        <div class="dmg-metric-card">
          <div class="dmg-metric-icon dmg-metric-icon--blue">
            <i class="fas fa-folder"></i>
          </div>
          <div class="dmg-metric-body">
            <div class="dmg-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummary"></span>
              <ng-container *ngIf="!isLoadingSummary">{{ summary.total | number }}</ng-container>
            </div>
            <div class="dmg-metric-label">Pratiche Totali</div>
          </div>
        </div>

        <div class="dmg-metric-card">
          <div class="dmg-metric-icon dmg-metric-icon--purple">
            <i class="fas fa-folder-open"></i>
          </div>
          <div class="dmg-metric-body">
            <div class="dmg-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummary"></span>
              <ng-container *ngIf="!isLoadingSummary">{{ summary.open | number }}</ng-container>
            </div>
            <div class="dmg-metric-label">Aperte</div>
          </div>
        </div>

        <div class="dmg-metric-card">
          <div class="dmg-metric-icon dmg-metric-icon--yellow">
            <i class="fas fa-cogs"></i>
          </div>
          <div class="dmg-metric-body">
            <div class="dmg-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummary"></span>
              <ng-container *ngIf="!isLoadingSummary">{{ summary.inProgress | number }}</ng-container>
            </div>
            <div class="dmg-metric-label">In lavorazione</div>
          </div>
        </div>

        <div class="dmg-metric-card">
          <div class="dmg-metric-icon dmg-metric-icon--orange">
            <i class="fas fa-hourglass-half"></i>
          </div>
          <div class="dmg-metric-body">
            <div class="dmg-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummary"></span>
              <ng-container *ngIf="!isLoadingSummary">{{ summary.waiting | number }}</ng-container>
            </div>
            <div class="dmg-metric-label">In attesa</div>
          </div>
        </div>

        <div class="dmg-metric-card">
          <div class="dmg-metric-icon dmg-metric-icon--red">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <div class="dmg-metric-body">
            <div class="dmg-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummary"></span>
              <ng-container *ngIf="!isLoadingSummary">{{ summary.overdue | number }}</ng-container>
            </div>
            <div class="dmg-metric-label">Scadute</div>
          </div>
        </div>

        <div class="dmg-metric-card">
          <div class="dmg-metric-icon dmg-metric-icon--green">
            <i class="fas fa-check-circle"></i>
          </div>
          <div class="dmg-metric-body">
            <div class="dmg-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummary"></span>
              <ng-container *ngIf="!isLoadingSummary">{{ summary.closed | number }}</ng-container>
            </div>
            <div class="dmg-metric-label">Chiuse</div>
          </div>
        </div>

        <div class="dmg-metric-card">
          <div class="dmg-metric-icon dmg-metric-icon--red">
            <i class="fas fa-ban"></i>
          </div>
          <div class="dmg-metric-body">
            <div class="dmg-metric-value">
              <span class="spinner-border spinner-border-sm" *ngIf="isLoadingSummary"></span>
              <ng-container *ngIf="!isLoadingSummary">{{ summary.rejected | number }}</ng-container>
            </div>
            <div class="dmg-metric-label">Respinte</div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- ─── SEZIONE 3: CLIENTI (una riga per cliente, conteggi per stato) ─── -->
  <div id="clients-section" class="card mb-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-users header-icon"></i>
          <h3>Clienti</h3>
        </div>
        <div class="d-flex align-items-center gap-3">
          <div class="dmg-summary-error" *ngIf="clientsErrorMessage" role="alert">
            <i class="fas fa-exclamation-circle dmg-summary-error-icon"></i>
            <span class="dmg-summary-error-text">{{ clientsErrorMessage }}</span>
            <button type="button" class="dmg-summary-error-retry"
                    (click)="retryClients()"
                    [disabled]="isLoadingClients"
                    title="Riprova a caricare i resoconti per cliente">
              <i class="fas fa-redo-alt" [class.fa-spin]="isLoadingClients"></i>
              Riprova
            </button>
          </div>

          <!-- Contatore clienti -->
          <div class="counter-display">
            <span class="badge bg-light text-muted" title="Clienti nella panoramica">
              <i class="fas fa-users me-1"></i>
              {{ clientRows.length | number }}
            </span>
          </div>

          <button type="button" class="btn btn-sm btn-outline-secondary"
                  (click)="toggleClientsCollapsed()"
                  [title]="isClientsCollapsed ? 'Espandi' : 'Comprimi'">
            <i class="fas" [ngClass]="isClientsCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="card-body p-0 results-table-body" *ngIf="!isClientsCollapsed" [class.table-compact]="isCompactTable">

      <!-- Overlay di caricamento (solo su dati già presenti) -->
      <div class="table-loading-overlay" *ngIf="isLoadingClients && clientRows.length > 0">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Caricamento...</span>
        </div>
      </div>

      <!-- Caricamento in corso (nessun dato ancora) -->
      <div class="empty-state text-center" *ngIf="clientRows.length === 0 && isLoadingClients">
        <div class="empty-state-icon mb-3">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Caricamento...</span>
          </div>
        </div>
        <h5 class="empty-state-title text-muted mb-2">Caricamento dei resoconti per cliente...</h5>
      </div>

      <!-- Nessun cliente -->
      <div class="empty-state text-center"
           *ngIf="hasLoadedClients && clientRows.length === 0 && !isLoadingClients && !clientsErrorMessage">
        <div class="empty-state-icon mb-3">
          <i class="fas fa-user-slash fa-3x text-muted"></i>
        </div>
        <h5 class="empty-state-title text-muted mb-2">Nessun cliente</h5>
        <p class="empty-state-subtitle text-muted small mb-0">
          Non ci sono clienti associati all'utente collegato per i filtri correnti.
        </p>
      </div>

      <!-- Tabella clienti -->
      <div class="table-responsive" *ngIf="clientRows.length > 0">
        <table class="table dmg-table dco-clients-table mb-0">
          <thead>
            <tr>
              <th style="width: 60px;">#</th>
              <th *ngFor="let col of clientColumns"
                  class="sortable-th"
                  [class.text-end]="col.numeric"
                  (click)="sortClientsBy(col.key)"
                  title="Clicca per ordinare">
                {{ col.label }}
                <i [class]="getClientSortIcon(col.key)"></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="dmg-row dco-client-row" *ngFor="let row of clientRows; let i = index; trackBy: trackByClientRow"
                [class.dco-client-row--focused]="isFocusedClient(row)"
                [class.dco-client-row--error]="row.error"
                [class.dco-client-row--empty]="!row.error && row.summary.total === 0"
                (click)="focusClient(row)"
                [title]="isFocusedClient(row) ? 'Togli il fuoco dal cliente' : 'Mostra solo le pratiche di ' + row.clientName">
              <td class="text-muted">{{ i + 1 }}</td>

              <!-- Cliente: nome, codice e numero di brand -->
              <td class="dco-client-cell">
                <div class="dco-client-name">
                  <i class="fas fa-user-check text-primary me-1" *ngIf="isFocusedClient(row)" title="Cliente a fuoco"></i>
                  {{ row.clientName }}
                </div>
                <div class="dco-client-meta">
                  <span class="dmg-code">{{ row.clientCode }}</span>
                  <span *ngIf="row.brandCount > 0" class="ms-2">
                    <i class="fas fa-tags me-1"></i>{{ row.brandCount }} brand
                  </span>
                  <span *ngIf="row.error" class="ms-2 text-danger" title="Resoconto non caricato">
                    <i class="fas fa-exclamation-circle me-1"></i>resoconto non disponibile
                  </span>
                </div>
              </td>

              <!-- Conteggi per stato -->
              <td class="text-end dco-num dco-num--total">{{ row.error ? '-' : (row.summary.total | number) }}</td>
              <td class="text-end dco-num">
                <span class="dmg-badge dmg-badge--info" *ngIf="!row.error && row.summary.open > 0; else zeroCell">{{ row.summary.open | number }}</span>
              </td>
              <td class="text-end dco-num">
                <span class="dmg-badge dmg-badge--pending" *ngIf="!row.error && row.summary.inProgress > 0; else zeroCell">{{ row.summary.inProgress | number }}</span>
              </td>
              <td class="text-end dco-num">
                <span class="dmg-badge dmg-badge--medium" *ngIf="!row.error && row.summary.waiting > 0; else zeroCell">{{ row.summary.waiting | number }}</span>
              </td>
              <td class="text-end dco-num">
                <span class="dmg-badge dmg-badge--critical" *ngIf="!row.error && row.summary.overdue > 0; else zeroCell">{{ row.summary.overdue | number }}</span>
              </td>
              <td class="text-end dco-num">
                <span class="dmg-badge dmg-badge--resolved" *ngIf="!row.error && row.summary.closed > 0; else zeroCell">{{ row.summary.closed | number }}</span>
              </td>
              <td class="text-end dco-num">
                <span class="dmg-badge dmg-badge--critical" *ngIf="!row.error && row.summary.rejected > 0; else zeroCell">{{ row.summary.rejected | number }}</span>
              </td>
            </tr>
          </tbody>
          <tfoot *ngIf="clientRows.length > 1">
            <tr class="dco-totals-row">
              <td></td>
              <td class="dco-client-cell">
                <div class="dco-client-name">Totale</div>
                <div class="dco-client-meta">{{ clientRows.length }} clienti</div>
              </td>
              <td class="text-end dco-num dco-num--total">{{ clientTotals.total | number }}</td>
              <td class="text-end dco-num">{{ clientTotals.open | number }}</td>
              <td class="text-end dco-num">{{ clientTotals.inProgress | number }}</td>
              <td class="text-end dco-num">{{ clientTotals.waiting | number }}</td>
              <td class="text-end dco-num">{{ clientTotals.overdue | number }}</td>
              <td class="text-end dco-num">{{ clientTotals.closed | number }}</td>
              <td class="text-end dco-num">{{ clientTotals.rejected | number }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>

  <!-- ─── SEZIONE 4: PRATICHE / COLLI (del cliente a fuoco, o di tutti) ─── -->
  <!-- Una sola card con due viste: il selettore nell'intestazione mostra la tabella
       delle pratiche (principale) oppure quella dei colli danneggiati -->
  <div id="table-section" class="card">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas header-icon" [ngClass]="activeTable === 'claims' ? 'fa-list' : 'fa-hammer'"></i>

          <!-- Selettore Pratiche / Colli -->
          <div class="dco-view-toggle" role="tablist" aria-label="Tabella da visualizzare">
            <button type="button" class="dco-view-btn" role="tab"
                    [class.active]="activeTable === 'claims'"
                    [attr.aria-selected]="activeTable === 'claims'"
                    (click)="showTable('claims')"
                    title="Mostra le pratiche danno">
              <i class="fas fa-folder-open me-1"></i>Pratiche
              <span class="dco-view-count" title="Pratiche trovate con i filtri correnti">
                <span class="spinner-border spinner-border-sm" *ngIf="isLoading && !hasLoaded"></span>
                <ng-container *ngIf="hasLoaded || !isLoading">{{ totalRecords | number }}</ng-container>
              </span>
            </button>
            <button type="button" class="dco-view-btn" role="tab"
                    [class.active]="activeTable === 'parcels'"
                    [attr.aria-selected]="activeTable === 'parcels'"
                    (click)="showTable('parcels')"
                    title="Mostra i colli danneggiati">
              <i class="fas fa-hammer me-1"></i>Colli
              <span class="dco-view-count" title="Colli danneggiati trovati con i filtri correnti">
                <span class="spinner-border spinner-border-sm" *ngIf="isLoadingParcels && !hasLoadedParcels"></span>
                <ng-container *ngIf="hasLoadedParcels || !isLoadingParcels">{{ parcelTotalRecords | number }}</ng-container>
              </span>
            </button>
          </div>

          <span class="dco-focus-chip" *ngIf="focusedClientName as name"
                [title]="(activeTable === 'claims' ? 'Pratiche del cliente ' : 'Colli danneggiati del cliente ') + name">
            <i class="fas fa-user me-1"></i>{{ name }}
            <button type="button" class="dco-focus-chip-clear" (click)="clearClientFocus()" title="Torna a tutti i clienti">
              <i class="fas fa-times"></i>
            </button>
          </span>
        </div>
        <div class="d-flex align-items-center gap-3">

          <!-- Elementi per pagina (come in /damage-overview), condivisi dalle due viste -->
          <div class="btn-group btn-group-sm pagination-selector" role="group">
            <button type="button" class="btn" *ngFor="let n of [5, 10, 25, 50, 100]"
                    [ngClass]="itemsPerPage === n ? 'btn-secondary' : 'btn-outline-secondary'"
                    (click)="setItemsPerPage(n)" [title]="n + ' elementi per pagina'">
              {{ n }}
            </button>
          </div>

        </div>
      </div>
    </div>

    <!-- Vista PRATICHE -->
    <div class="card-body p-0 results-table-body" *ngIf="activeTable === 'claims'" [class.table-compact]="isCompactTable">

      <!-- Overlay di caricamento (solo su dati già presenti) -->
      <div class="table-loading-overlay" *ngIf="isLoading && rows.length > 0">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Caricamento...</span>
        </div>
      </div>

      <!-- Errore -->
      <div class="empty-state text-center" *ngIf="tableErrorMessage && !isLoading">
        <div class="empty-state-icon mb-3">
          <i class="fas fa-exclamation-triangle fa-3x text-warning"></i>
        </div>
        <h5 class="empty-state-title text-muted mb-2">Errore nel caricamento delle pratiche</h5>
        <p class="empty-state-subtitle text-muted small mb-0">{{ tableErrorMessage }}</p>
        <button type="button" class="btn btn-primary btn-sm mt-3" (click)="refreshData()">
          <i class="fas fa-redo-alt me-1"></i> Riprova
        </button>
      </div>

      <!-- Caricamento in corso (nessun dato ancora) -->
      <div class="empty-state text-center" *ngIf="rows.length === 0 && isLoading">
        <div class="empty-state-icon mb-3">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Caricamento...</span>
          </div>
        </div>
        <h5 class="empty-state-title text-muted mb-2">Caricamento delle pratiche...</h5>
      </div>

      <!-- Nessuna pratica -->
      <div class="empty-state text-center"
           *ngIf="hasLoaded && rows.length === 0 && !isLoading && !tableErrorMessage">
        <div class="empty-state-icon mb-3">
          <i class="fas fa-clipboard-check fa-3x text-muted"></i>
        </div>
        <h5 class="empty-state-title text-muted mb-2">Nessuna pratica trovata</h5>
        <p class="empty-state-subtitle text-muted small mb-0">
          Prova a modificare i filtri di ricerca o a scegliere un altro cliente.
        </p>
      </div>

      <!-- Tabella -->
      <div class="table-responsive" *ngIf="rows.length > 0">
        <table class="table dmg-table mb-0">
          <thead>
            <tr>
              <th style="width: 60px;">#</th>
              <th *ngFor="let col of columns"
                  [class.sortable-th]="col.sortable"
                  (click)="sortBy(col)"
                  [title]="col.sortable ? 'Clicca per ordinare' : ''">
                {{ col.label }}
                <i *ngIf="col.sortable" [class]="getSortIcon(col)"></i>
              </th>
              <th>Azione</th>
            </tr>
          </thead>
          <tbody>
            <tr class="dmg-row dco-row" *ngFor="let damage of rows; let i = index; trackBy: trackByDamage"
                [class.dco-row--overdue]="isOverdue(damage)"
                (click)="openDetail(damage)">
              <td class="text-muted">{{ rowNumber(i) }}</td>
              <td *ngFor="let col of columns"
                  [class.dmg-code]="col.type === 'text'"
                  [class.dmg-date]="col.type === 'date'"
                  [class.dco-client-col]="col.type === 'client'"
                  [ngSwitch]="col.type">
                <ng-container *ngSwitchCase="'date'">
                  <ng-container *ngIf="dateValue(damage, col); else emptyCell">
                    {{ dateValue(damage, col) | date:'dd/MM/yy HH:mm' }}
                    <i class="fas fa-exclamation-circle text-danger ms-1"
                       *ngIf="col.key === 'damageDueDate' && isOverdue(damage)" title="Scadenza superata"></i>
                  </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'status'">
                  <span class="dmg-badge" [ngClass]="statusBadgeClass(damage.damageStatus)">
                    {{ damage.damageStatus ? ('DAMAGES.STATUS.' + damage.damageStatus | translate) : '-' }}
                  </span>
                </ng-container>
                <ng-container *ngSwitchCase="'severity'">
                  <span class="dmg-badge" [ngClass]="severityBadgeClass(damage.damageSeverity)">
                    {{ damage.damageSeverity ? ('DAMAGES.SEVERITY.' + damage.damageSeverity | translate) : '-' }}
                  </span>
                </ng-container>
                <ng-container *ngSwitchCase="'type'">
                  <ng-container *ngIf="damage.damageType; else emptyCell">
                    {{ 'DAMAGES.TYPE.' + damage.damageType | translate }}
                  </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'client'">
                  <div class="dco-client-name">{{ clientName(damage) || '-' }}</div>
                </ng-container>
                <ng-container *ngSwitchCase="'user'">
                  <ng-container *ngIf="userName($any(cellValue(damage, col))) as name; else emptyCell">
                    <span [title]="cellValue(damage, col)">{{ name }}</span>
                  </ng-container>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <ng-container *ngIf="cellValue(damage, col) != null && cellValue(damage, col) !== ''; else emptyCell">
                    {{ cellValue(damage, col) }}
                  </ng-container>
                </ng-container>
              </td>
              <td>
                <button type="button" class="dmg-claim-btn dmg-claim-btn--manage"
                        (click)="$event.stopPropagation(); openDetail(damage)"
                        [title]="'Apri la pratica danno #' + damage.damageId">
                  <i class="fas fa-folder-open me-1"></i>Gestisci
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginazione (stessa barra di /damage-overview) -->
      <div class="pagination-container" *ngIf="totalRecords > 0 && !tableErrorMessage">
        <div class="pagination-controls">
          <button class="pagination-btn" (click)="onPageChange(1)"
                  [disabled]="currentPage === 1" aria-label="Prima pagina" title="Prima pagina">
            <i class="fas fa-angles-left"></i>
          </button>

          <button class="pagination-btn" (click)="onPageChange(currentPage - 1)"
                  [disabled]="currentPage === 1" aria-label="Precedente" title="Precedente">
            <i class="fas fa-chevron-left"></i>
          </button>

          <div class="page-numbers">
            <ng-container *ngFor="let page of getPageItems(); trackBy: trackByPageItem">
              <span class="pagination-ellipsis" *ngIf="page === null">…</span>
              <button *ngIf="page !== null"
                      class="pagination-number"
                      [class.active]="page === currentPage"
                      (click)="onPageChange(page)"
                      [attr.aria-label]="'Pagina ' + page"
                      [title]="'Vai alla pagina ' + page">
                {{ page }}
              </button>
            </ng-container>
          </div>

          <!-- Vai a pagina -->
          <div class="page-jump">
            <button class="pagination-btn" *ngIf="!isPageJumpOpen" (click)="openPageJump()"
                    aria-label="Vai a pagina" title="Vai a pagina...">
              <i class="fas fa-hashtag"></i>
            </button>
            <div class="page-jump-field" *ngIf="isPageJumpOpen">
              <input #pageJumpInput type="number" class="page-jump-input" min="1"
                     [max]="totalPages" [value]="pageJumpValue" [placeholder]="' / ' + totalPages"
                     (input)="pageJumpValue = $any($event.target).value"
                     (keydown.enter)="applyPageJump()" (keydown.escape)="closePageJump()" (blur)="closePageJump()">
              <button type="button" class="page-jump-go"
                      (mousedown)="$event.preventDefault()" (click)="applyPageJump()"
                      aria-label="Vai" title="Vai alla pagina">
                <i class="fas fa-level-down-alt fa-rotate-90"></i>
              </button>
            </div>
          </div>

          <span class="pagination-info">
            {{ rangeStart }} - {{ rangeEnd }} di {{ totalRecords }}
          </span>

          <!-- Vai all'elemento -->
          <div class="page-jump">
            <button class="pagination-btn" *ngIf="!isItemJumpOpen" (click)="openItemJump()"
                    aria-label="Vai a elemento" title="Vai all'elemento numero...">
              <i class="fas fa-list-ol"></i>
            </button>
            <div class="page-jump-field" *ngIf="isItemJumpOpen">
              <input #itemJumpInput type="number" class="page-jump-input" min="1"
                     [max]="totalRecords" [value]="itemJumpValue" [placeholder]="' / ' + totalRecords"
                     (input)="itemJumpValue = $any($event.target).value"
                     (keydown.enter)="applyItemJump()" (keydown.escape)="closeItemJump()" (blur)="closeItemJump()">
              <button type="button" class="page-jump-go"
                      (mousedown)="$event.preventDefault()" (click)="applyItemJump()"
                      aria-label="Vai" title="Vai all'elemento">
                <i class="fas fa-level-down-alt fa-rotate-90"></i>
              </button>
            </div>
          </div>

          <button class="pagination-btn" (click)="onPageChange(currentPage + 1)"
                  [disabled]="currentPage === totalPages" aria-label="Successivo" title="Successivo">
            <i class="fas fa-chevron-right"></i>
          </button>

          <button class="pagination-btn" (click)="onPageChange(totalPages)"
                  [disabled]="currentPage === totalPages" aria-label="Ultima pagina" title="Ultima pagina">
            <i class="fas fa-angles-right"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Vista COLLI DANNEGGIATI -->
    <div class="card-body p-0 results-table-body" *ngIf="activeTable === 'parcels'" [class.table-compact]="isCompactTable">

      <!-- Overlay di caricamento (solo su dati già presenti) -->
      <div class="table-loading-overlay" *ngIf="isLoadingParcels && parcelRows.length > 0">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Caricamento...</span>
        </div>
      </div>

      <!-- Errore -->
      <div class="empty-state text-center" *ngIf="parcelsErrorMessage && !isLoadingParcels">
        <div class="empty-state-icon mb-3">
          <i class="fas fa-exclamation-triangle fa-3x text-warning"></i>
        </div>
        <h5 class="empty-state-title text-muted mb-2">Errore nel caricamento dei colli</h5>
        <p class="empty-state-subtitle text-muted small mb-0">{{ parcelsErrorMessage }}</p>
        <button type="button" class="btn btn-primary btn-sm mt-3" (click)="retryParcels()">
          <i class="fas fa-redo-alt me-1"></i> Riprova
        </button>
      </div>

      <!-- Caricamento in corso (nessun dato ancora) -->
      <div class="empty-state text-center" *ngIf="parcelRows.length === 0 && isLoadingParcels">
        <div class="empty-state-icon mb-3">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Caricamento...</span>
          </div>
        </div>
        <h5 class="empty-state-title text-muted mb-2">Caricamento dei colli danneggiati...</h5>
      </div>

      <!-- Nessun collo -->
      <div class="empty-state text-center"
           *ngIf="hasLoadedParcels && parcelRows.length === 0 && !isLoadingParcels && !parcelsErrorMessage">
        <div class="empty-state-icon mb-3">
          <i class="fas fa-box-open fa-3x text-muted"></i>
        </div>
        <h5 class="empty-state-title text-muted mb-2">Nessun collo danneggiato</h5>
        <p class="empty-state-subtitle text-muted small mb-0">
          Prova a modificare i filtri di ricerca o a scegliere un altro cliente.
        </p>
      </div>

      <!-- Tabella colli -->
      <div class="table-responsive" *ngIf="parcelRows.length > 0">
        <table class="table dmg-table mb-0">
          <thead>
            <tr>
              <th style="width: 60px;">#</th>
              <th *ngFor="let col of parcelColumns"
                  [class.sortable-th]="col.sortable"
                  (click)="sortParcelsBy(col)"
                  [title]="col.sortable ? 'Clicca per ordinare' : ''">
                {{ col.label }}
                <i *ngIf="col.sortable" [class]="getParcelSortIcon(col)"></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="dmg-row dco-parcel-row" *ngFor="let row of parcelRows; let i = index; trackBy: trackByParcel"
                (click)="openParcel(row)">
              <td class="text-muted">{{ parcelRowNumber(i) }}</td>
              <td *ngFor="let col of parcelColumns"
                  [class.dmg-code]="col.type === 'text'"
                  [class.dmg-date]="col.type === 'date'"
                  [class.dco-client-col]="col.type === 'client'"
                  [ngSwitch]="col.type">
                <ng-container *ngSwitchCase="'client'">
                  <div class="dco-client-name">{{ parcelClientName(row) || '-' }}</div>
                </ng-container>
                <ng-container *ngSwitchCase="'date'">
                  <ng-container *ngIf="row[col.key]; else emptyCell">{{ row[col.key] | date:'dd/MM/yy HH:mm' }}</ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'number'">
                  <ng-container *ngIf="row[col.key] != null; else emptyCell">{{ row[col.key] | number:'1.0-3' }}</ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'action'">
                  <!-- Un solo bottone per riga, come in /damaged-parcels: nessuna pratica -> apri nuova;
                       una pratica -> visualizza; più pratiche -> popup "Pratiche danno del collo" -->
                  <button type="button" class="dmg-claim-btn"
                          *ngIf="claimsOf(row).length === 0"
                          title="Apri una nuova pratica danno per questo collo"
                          (click)="openNewClaim(row, $event)">
                    <i class="fas fa-plus me-1"></i>Apri Pratica Danno
                  </button>
                  <button type="button" class="dmg-claim-btn dmg-claim-btn--manage"
                          *ngIf="claimsOf(row).length === 1"
                          [title]="'Visualizza la pratica danno ' + (claimsOf(row)[0].damageCode || '#' + claimsOf(row)[0].damageId)"
                          (click)="openSingleClaim(row, $event)">
                    <i class="fas fa-folder-open me-1"></i>Visualizza Pratica
                  </button>
                  <button type="button" class="dmg-claim-btn dmg-claim-btn--manage"
                          *ngIf="claimsOf(row).length > 1"
                          [title]="claimsOf(row).length + ' pratiche danno per questo collo: clicca per vederle'"
                          (click)="openClaimsPopup(row, $event)">
                    <i class="fas fa-history me-1"></i>Visualizza lista pratiche ({{ claimsOf(row).length }})
                  </button>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <ng-container *ngIf="row[col.key] != null && row[col.key] !== ''; else emptyCell">{{ row[col.key] }}</ng-container>
                </ng-container>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginazione (stessa barra della tabella Pratiche) -->
      <div class="pagination-container" *ngIf="parcelTotalRecords > 0 && !parcelsErrorMessage">
        <div class="pagination-controls">
          <button class="pagination-btn" (click)="onParcelPageChange(1)"
                  [disabled]="parcelPage === 1" aria-label="Prima pagina" title="Prima pagina">
            <i class="fas fa-angles-left"></i>
          </button>

          <button class="pagination-btn" (click)="onParcelPageChange(parcelPage - 1)"
                  [disabled]="parcelPage === 1" aria-label="Precedente" title="Precedente">
            <i class="fas fa-chevron-left"></i>
          </button>

          <div class="page-numbers">
            <ng-container *ngFor="let page of getParcelPageItems(); trackBy: trackByPageItem">
              <span class="pagination-ellipsis" *ngIf="page === null">…</span>
              <button *ngIf="page !== null"
                      class="pagination-number"
                      [class.active]="page === parcelPage"
                      (click)="onParcelPageChange(page)"
                      [attr.aria-label]="'Pagina ' + page"
                      [title]="'Vai alla pagina ' + page">
                {{ page }}
              </button>
            </ng-container>
          </div>

          <span class="pagination-info">
            {{ parcelRangeStart }} - {{ parcelRangeEnd }} di {{ parcelTotalRecords }}
          </span>

          <button class="pagination-btn" (click)="onParcelPageChange(parcelPage + 1)"
                  [disabled]="parcelPage === parcelTotalPages" aria-label="Successivo" title="Successivo">
            <i class="fas fa-chevron-right"></i>
          </button>

          <button class="pagination-btn" (click)="onParcelPageChange(parcelTotalPages)"
                  [disabled]="parcelPage === parcelTotalPages" aria-label="Ultima pagina" title="Ultima pagina">
            <i class="fas fa-angles-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- Popup con tutte le pratiche danno del collo (storico), come in /damaged-parcels -->
<app-parcel-claims-popup
  [visible]="claimsPopupRow !== null"
  [parcelCode]="claimsPopupRow ? (claimsPopupRow['parcelCode'] || '') : ''"
  [claims]="claimsPopupRow ? claimsOf(claimsPopupRow) : []"
  (closed)="closeClaimsPopup()"
  (openClaim)="openClaimFromPopup($event)">
</app-parcel-claims-popup>

<ng-template #emptyCell><span class="text-muted">-</span></ng-template>
<ng-template #zeroCell><span class="text-muted dco-zero">0</span></ng-template>

<!-- Accesso negato -->
<div class="text-center py-5" *ngIf="!canRead()">
  <i class="fas fa-lock fa-3x text-muted mb-3"></i>
  <h5 class="text-muted">Accesso negato</h5>
  <p class="text-muted">Non hai i permessi per visualizzare questa sezione.</p>
</div>
